(function(){
'use strict';

/**
 * This is a wrapper around the /frs-api/i18n/default-locale endpoint.
 *
 * This is a client-initiated call which allows us to replace the server-initiated
 * call that tied the default-currency calculation to the user logic.
 *
 * This endpoint was added to make other endpoints user-independent, and
 * therefore cacheable.
 *
 * @param $log
 * @param $http
 * @param $location
 */
scDefaultCurrencyService.$inject = ["$log", "$http", "$location"];
function scDefaultCurrencyService($log, $http, $location) {
  'use strict';

  var _cachedLocaleCurrency = void 0;

  var fetchDefaultCurrency = function fetchDefaultCurrency() {
    return $http.get('/frs-api/i18n/default-locale').then(function (response) {
      return response && response.data && response.data.data && response.data.data.currency ? response.data.data.currency : undefined;
    }).catch(function (error) {
      $log.error('Failed to fetch default locale:', error);
      return undefined;
    });
  };

  /**
   * Load the default currency for the current user and put it in the cache.
   *
   * It may be undefined.
   *
   * side effect: this caches the user's default currency.
   *
   * @returns {Promise<string | undefined>}
   */
  var fetchDefaultCurrencyWithCache = function fetchDefaultCurrencyWithCache() {
    if (!_cachedLocaleCurrency) {
      return fetchDefaultCurrency().then(function (response) {
        _cachedLocaleCurrency = response;
        return Promise.resolve(response);
      }).catch(function (error) {
        $log.error('Failed to fetch default locale:', error);
        return Promise.reject(error);
      });
    } else {
      return Promise.resolve(_cachedLocaleCurrency);
    }
  };

  /**
   * find the currency from the list of available currencies.
   *
   * if nothing matches, it does not select one.
   *
   * side-effect: it checks in the location for an override.
   *
   * @returns {string|undefined}
   * @private
   */
  var findDefaultCurrencyFromCache = function findDefaultCurrencyFromCache() {
    /** @type {Array<Currency>} */
    var availableCurrencies = SC.currencies && SC.currencies.data || [];
    // We should move the "location" access outside this call, maybe to the client.
    if ($location.search().currency) {
      return undefined;
    }

    return availableCurrencies.find(function (locale) {
      return locale.currency === _cachedLocaleCurrency;
    }) ? _cachedLocaleCurrency : undefined;
  };

  return {
    /**
     * fetch the cached currency value, or the default.
     */
    findDefaultCurrencyFromCache: findDefaultCurrencyFromCache,
    fetchDefaultCurrency: fetchDefaultCurrency,
    fetchDefaultCurrencyWithCache: fetchDefaultCurrencyWithCache
  };
}

angular.module('classy').service('scDefaultCurrencyService', scDefaultCurrencyService);
})();